module.exports = __webpack_public_path__ + "static/media/logoHemav.c2ca2aa9.png";